import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withMyUserId } from '../Common/Decorators';
import UserComplianceStore from '../../stores/UserComplianceStore';
import { Container } from 'flux/utils';
import { listUserCompliances } from '../../actions/UserActionCreator';

import ComplianceSegment from './ComplianceSegment';


class Compliance extends Component {

    componentDidMount() {
        listUserCompliances(this.props.userId);
    }

    render() {

        const { compliances } = this.state;
        if (!compliances || compliances.length === 0) { return false; }

        return (
            <div className="cent-flex-row" >
            {compliances && compliances.map(c => <ComplianceSegment key={c.complianceId} {...c} />)}
            </div>
        );
    }

}


Compliance.getStores = () => ([UserComplianceStore]);
Compliance.calculateState = (prevState, {userId}) => ({
    isFetching: UserComplianceStore.isFetching(),
    compliances: UserComplianceStore.getByUser(userId)
});


Compliance.propTypes = {
    userId: PropTypes.number.isRequired,
};

Compliance.contextTypes = {
    auth: PropTypes.object.isRequired
};


const ComplianceContainer = Container.create(Compliance, {withProps: true});

export default ComplianceContainer;
export const MyComplianceContainer = withMyUserId(ComplianceContainer);
